import React, { useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const EscopoDialog = props => {
  const { t, isOpen, onCancel, onConfirm, vencimentoMudou } = props
  const [escopo, setEscopo] = useState("esta")

  return (
    <Modal isOpen={ isOpen } centered backdrop="static">
      <ModalHeader>{ t("contaspagar.recorrencia.escopo.titulo") }</ModalHeader>
      <ModalBody>
        <div className="form-check mb-2">
          <input className="form-check-input" type="radio" id="escopo-esta"
                 checked={ escopo === "esta" } onChange={ () => setEscopo("esta") } />
          <label className="form-check-label" htmlFor="escopo-esta">
            { t("contaspagar.recorrencia.escopo.esta") }
          </label>
        </div>
        <div className="form-check mb-2">
          <input className="form-check-input" type="radio" id="escopo-futuras"
                 checked={ escopo === "futuras" } onChange={ () => setEscopo("futuras") } />
          <label className="form-check-label" htmlFor="escopo-futuras">
            { t("contaspagar.recorrencia.escopo.futuras") }
          </label>
        </div>
        <div className="form-check mb-2">
          <input className="form-check-input" type="radio" id="escopo-todas"
                 checked={ escopo === "todas" } onChange={ () => setEscopo("todas") } />
          <label className="form-check-label" htmlFor="escopo-todas">
            { t("contaspagar.recorrencia.escopo.todas") }
          </label>
        </div>
        <small className="text-muted">{ t("contaspagar.recorrencia.escopo.aviso_pagas") }</small>

        { vencimentoMudou && escopo !== "esta" && (
          <div className="alert alert-warning mt-3">
            { t("contaspagar.recorrencia.warning.vencimento_em_massa") }
          </div>
        ) }
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={ () => { const e = escopo; setEscopo("esta"); onConfirm(e) } }>{ t("contaspagar.recorrencia.escopo.confirmar") }</Button>
        <Button color="secondary" onClick={ () => { setEscopo("esta"); onCancel() } }>{ t("contaspagar.recorrencia.escopo.cancelar") }</Button>
      </ModalFooter>
    </Modal>
  )
}

EscopoDialog.propTypes = {
  isOpen: PropTypes.bool,
  vencimentoMudou: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default withTranslation()(EscopoDialog)
